/**
 * ui-router 0.3 rejects the transition promise with these messages during normal
 * navigation: a second click supersedes the first, a resolve calls `event.preventDefault()`,
 * or a state guard aborts. They are not failures and must not surface to the user.
 */
const IGNORED_TRANSITION_ERRORS: string[] = [
  'transition superseded',
  'transition prevented',
  'transition aborted'
];

export function isIgnoredTransitionError(error: any): boolean {
  if (!error) {
    return false;
  }

  const message = error.message || error;
  return IGNORED_TRANSITION_ERRORS.indexOf(message) !== -1;
}
